export default __webpack_public_path__ + "static/media/pdf-icon.73d19d81.svg";